import { render, staticRenderFns } from "./NotificationAddModal.vue?vue&type=template&id=c7d58d20&"
import script from "./NotificationAddModal.vue?vue&type=script&lang=js&"
export * from "./NotificationAddModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports